module.exports = {
  title: '平台首页',
  route: {
    path: '/index',
    children: {
      path: '',
    },
  },
};
